import { Injectable, inject, signal } from '@angular/core';

import { BackendService } from 'src/app/services/backend.service';
import { JwtService } from 'src/app/services/jwt.service';


/**
 * Whether the logged-in user can use time tracking: needs a linked Caresonal personnel record and the switch on in
 * Caresonal. Asked once per login, so the user menu does not show a dead entry.
 */
@Injectable({
  providedIn: 'root'
})
export class TimeTrackingAvailabilityService {
  private readonly backend = inject(BackendService);
  private readonly jwtService = inject(JwtService);

  readonly available = signal(false);
  private loadedFor: number | null = null;

  constructor() {
    this.jwtService.$loginChange.subscribe(() => {
      this.loadedFor = null;
      this.available.set(false);
      this.refresh();
    });
  }

  refresh(): void {
    const userId = this.jwtService.userData?.userId ?? null;
    if (!userId || this.loadedFor === userId) return;
    this.loadedFor = userId;

    this.backend
      .get<'timeTracking/status'>('time-tracking/status', { ignoredErrors: [0, 401, 403, 404, 502] })
      .subscribe((status) => this.available.set(!!status?.timeTrackingEnabled));
  }
}
